<div class="create-tournament">
  <p class="create-tournament__title">Crear Torneo</p>
  @if (createTournamentForm) {
  <form [formGroup]="createTournamentForm">
    <ion-item>
      <ion-input
        formControlName="name"
        label-placement="floating"
        label="Nombre del torneo"
        placeholder="Ingrese el nombre del torneo"
      ></ion-input>
    </ion-item>
  </form>
  }
  <div class="footer-btns">
    <ion-button
      color="primary"
      [disabled]="createTournamentForm?.invalid"
      (click)="createTournament()"
      >Crear</ion-button
    >
    <ion-button color="medium" (click)="cancel()">Cancelar</ion-button>
  </div>
</div>
